export default {
    methods: {
        hooverModeEnable() {
            return false;
        },
    },
};